import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { get } from 'lodash';
import { Subscription } from 'rxjs';

import { AvailableLang } from 'ideta-library/lib/utils/utils';

import { ProtocolDroidService } from '../shared/protocol-droid/services/protocol-droid.service';
import { AuthService } from '../shared/services/auth/auth.service';
import { FeedbackService } from '../shared/services/feedback/feedback.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('signInAnimation', [
      state(
        'form',
        style({
          transform: 'translateY(0)'
        })
      ),
      state(
        'spinner',
        style({
          transform: 'translateY(-180px)'
        })
      ),
      transition('* => *', animate('.2s ease-out'))
    ])
  ]
})
export class LoginComponent implements OnInit, OnDestroy {
  credentials: any;
  customMessage: string;
  emailInput: string;
  signInStatus: string;
  signInError: string;
  private subscriptions: Subscription[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private protocolDroidService: ProtocolDroidService,
    private feedbackService: FeedbackService
  ) {
    this.subscriptions = [];
  }

  ngOnInit() {
    setTimeout(() => {
      this.feedbackService.hideSpinner();
    }, 1000);
    this.protocolDroidService.setLang((get(navigator, 'language') as AvailableLang) || get(navigator, 'userLanguage'));
    this.subscriptions.push(
      this.authService.getAuth().subscribe(() => {
        this.router.navigate(['/accounts']);
      }),
      this.route.queryParamMap.subscribe((params: ParamMap) => {
        this.customMessage = params.get('message');
        this.emailInput = params.get('email');
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  loginWithCredentials(event: any, email: string, password: string): void {
    // Necessary to stop events from ENTER key
    event.stopPropagation();
    event.preventDefault();
    this.signInError = null;
    this.authService.loginWithCredentials({ email, password }).catch(() => {
      this.signInError = this.protocolDroidService.translate('login.invalid-credentials');
    });
  }

  googleAuth(): void {
    this.authService.signinWithGoogle();
  }

  microsoftAuth(): void {
    this.authService.signinWithMicrosoft();
  }

  handleSignInError(): boolean {
    if (this.signInError) {
      return true;
    } else return false;
  }
}
